import { NgModule } from '@angular/core';

import { CmpsLazyI18nModule } from '../../i18n/i18n.module';

import { TranslationIdMap } from './new-transcript-dialog.i18n';
import { CoachingNewTranscriptDialogService } from './new-transcript-dialog.service';

@NgModule({
    imports: [CmpsLazyI18nModule.forChild(TranslationIdMap)],
    providers: [CoachingNewTranscriptDialogService],
})
export class CmpsCoachingNewTranscriptDialogModule {}
